export enum BenchmarkStatus {
  TOP_PERFORMER = 'TOP_PERFORMER',
  NEED_A_BOOST = 'NEED_A_BOOST',
  DOING_GREAT = 'DOING_GREAT',
}
